import { render, staticRenderFns } from "./sub-category-list.vue?vue&type=template&id=0bdc5f0a&"
import script from "./sub-category-list.vue?vue&type=script&lang=js&"
export * from "./sub-category-list.vue?vue&type=script&lang=js&"
import style0 from "./sub-category-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports